import { useHeaderNavigationContext } from "../context/HeaderNavigationContext";
import useNavigateToSection from "../hooks/useNavigateToSection";
import Container from "./Container";

interface HeaderContextType {
  isNavOpen: boolean;
  setIsNavOpen: (isOpen: boolean) => void;
}

const Header: React.FC = () => {
  const navigateToSection = useNavigateToSection();
  const { isNavOpen, setIsNavOpen, sectionId, setSectionId } =
    useHeaderNavigationContext();

  return (
    <header className="fixed shadow-lg bg-white w-full">
      <Container>
        <div className="flex justify-between">
          <h1 className="py-6 font-bold text-2xl tracking-wider my-auto">
            <a href=".">MIZUKI</a>
          </h1>

          <div className="flex items-center justify-between  py-8">
            <nav>
              <section className="MOBILE-MENU flex lg:hidden">
                <div
                  className="HAMBURGER-ICON space-y-2"
                  onClick={() => setIsNavOpen(!isNavOpen)} // toggle isNavOpen state on click
                >
                  <span className="block h-0.5 rounded-full w-8 animate-pulse bg-3"></span>
                  <span className="block h-0.5 rounded-full w-8 animate-pulse bg-3"></span>
                  <span className="block h-0.5 rounded-full w-8 animate-pulse bg-3"></span>
                </div>

                <div className={isNavOpen ? "showMenuNav" : "hideMenuNav"}>
                  <div
                    className="CROSS-ICON absolute top-0 right-0 px-8 py-8"
                    onClick={() => setIsNavOpen(false)} // change isNavOpen state to false to close the menu
                  >
                    <svg
                      className="h-8 w-8 text-gray-600"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </div>
                  <ul className="MENU-LINK-MOBILE-OPEN flex flex-col items-center justify-between min-h-[250px] font-bold">
                    <li className="border-b h-color my-8 ">
                      <button onClick={() => navigateToSection("works")}>
                        WORKS
                      </button>
                    </li>
                    <li className="border-b h-color my-8 ">
                      <button onClick={() => navigateToSection("skill")}>
                        SKILL
                      </button>
                    </li>
                    <li className="border-b h-color my-8 ">
                      <button onClick={() => navigateToSection("about")}>
                        ABOUT
                      </button>
                    </li>
                    <li className="border-b h-color my-8 ">
                      <button onClick={() => navigateToSection("contact")}>
                        CONTACT
                      </button>
                    </li>
                  </ul>
                </div>
              </section>

              <ul className="DESKTOP-MENU hidden space-x-8 lg:flex h-color font-bold">
                <li>
                  <button onClick={() => navigateToSection("works")}>
                    WORKS
                  </button>
                </li>
                <li>
                  <button onClick={() => navigateToSection("skill")}>
                    SKILL
                  </button>
                </li>
                <li>
                  <button onClick={() => navigateToSection("about")}>
                    ABOUT
                  </button>
                </li>
                <li>
                  <button onClick={() => navigateToSection("contact")}>
                    CONTACT
                  </button>
                </li>
              </ul>
            </nav>
            <style>{`
      .hideMenuNav {
        display: none;
      }
      .showMenuNav {
        display: block;
        position: absolute;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        background: white;
        z-index: 10;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
      }
    `}</style>
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
